import { Link, type LinkProps } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import React from "react";

export function ExternalLink(props: LinkProps & { hideIcon?: boolean }) {
  const { children, hideIcon, ...restProps } = props;
  return (
    <Link target="_blank" {...restProps} sx={{ display: "inline-flex", alignItems: "center" }}>
      {children}
      {!hideIcon && <OpenInNewIcon sx={{ fontSize: 12, ml: 0.25, transform: "translateY(1px)" }} />}
    </Link>
  );
}
